import type { SupportedCountry } from '@archipro-website/localisation';

/**
 * Demonym used in the HDE intro copy, e.g. "New Zealand homeowners" or
 * "Australian homeowners". Keyed by market so the evening positioning reads
 * naturally per site/event country.
 */
const HDE_HOMEOWNER_DEMONYM: Record<SupportedCountry, string> = {
    NZ: 'New Zealand',
    AU: 'Australian',
    US: 'American',
};

/**
 * Returns the homeowner demonym for the given market, falling back to New
 * Zealand (ArchiPro's origin market) for any unexpected code.
 */
export const getHDEHomeownerDemonym = (country: SupportedCountry): string =>
    HDE_HOMEOWNER_DEMONYM[country] ?? HDE_HOMEOWNER_DEMONYM.NZ;

/**
 * Possessive market name used in HDE copy, e.g. "from NZ's leading brands" or
 * "from Australia's leading brands". Keyed by market so the AU page never
 * references New Zealand.
 */
const HDE_MARKET_POSSESSIVE: Record<SupportedCountry, string> = {
    NZ: "NZ's",
    AU: "Australia's",
    US: "America's",
};

/**
 * Returns the possessive market name for the given market, falling back to New
 * Zealand (ArchiPro's origin market) for any unexpected code.
 */
export const getHDEMarketPossessive = (country: SupportedCountry): string =>
    HDE_MARKET_POSSESSIVE[country] ?? HDE_MARKET_POSSESSIVE.NZ;
